var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReturns = function SvgReturns(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 20,
    viewBox: "0 0 16 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 4.172V5.91c0 .438.54.651.85.34l2.79-2.71c.2-.194.2-.495 0-.69L8.85.14C8.54-.16 8 .053 8 .49V2.23c-4.42 0-8 3.477-8 7.77 0 1.011.2 1.982.57 2.866.27.651 1.13.826 1.64.33.27-.262.38-.66.23-1.01C2.15 11.515 2 10.767 2 10c0-3.215 2.69-5.828 6-5.828zm5.79 2.632c-.27.262-.38.67-.23 1.01.28.68.44 1.418.44 2.186 0 3.215-2.69 5.828-6 5.828v-1.739c0-.437-.54-.65-.85-.34l-2.79 2.71c-.2.195-.2.496 0 .69l2.79 2.71c.31.301.85.088.85-.34v-1.748c4.42 0 8-3.478 8-7.771 0-1.01-.2-1.982-.57-2.866-.27-.65-1.13-.825-1.64-.33z"
  })));
};
export default SvgReturns;